module.exports = __webpack_public_path__ + "media/images/success-0e6c78a4.svg";